import {NgModule} from '@angular/core';
import {AsyncCurrencyPipe} from './pipes/async-currency.pipe';
import {InvoiceNumberPipe} from './pipes/invoice-number.pipe';
import {SafePipe} from './pipes/safe.pipe';
import {CamelToTitleCasePipe} from './pipes/camelToTitleCase.pipe';
import {EmptyDashPipe} from './pipes/empty-dash.pipe';
import {DeleteConfirmationDirective} from './directives/delete-confirmation.directive';
import {DeleteConfirmationComponent} from './components/delete-confirmation/delete-confirmation.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DurationPipe} from './pipes/duration.pipe';
import {ProceedConfirmationDirective} from './directives/proceed-confirmation.directive';
import {ProceedConfirmationComponent} from './components/proceed-confirmation/proceed-confirmation.component';
import {LocalDateTimePipe} from './pipes/local-date-time.pipe';
import {ReadonlyStylingDirective} from './directives/readonly-styling.directive';
import {CreditorResolvePipe} from './pipes/resolvers/creditor.resolve.pipe';
import {DebtorResolvePipe} from './pipes/resolvers/debtor.resolve.pipe';
import {CloseConfirmationComponent} from './components/close-confirmation/close-confirmation.component';
import {StockResolvePipe} from './pipes/resolvers/stock.resolve.pipe';
import {UserResolvePipe} from './pipes/resolvers/user.resolve.pipe';
import {EngineResolvePipe} from './pipes/resolvers/engine.resolve.pipe';
import {JobResolvePipe} from './pipes/resolvers/job.resolve.pipe';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {InputNumberOnlyDirective} from './directives/input-number-only.directive';
import {PaymentGatewayComponent} from './components/payment-components/payment-gateway/payment-gateway.component';
import {SecurePayComponent} from './components/payment-components/secure-pay/secure-pay.component';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {StripeComponent} from './components/payment-components/stripe/stripe.component';
import {NgxStripeModule} from 'ngx-stripe';
import {environment} from '../environments/environment';
import {LottieComponent} from 'ngx-lottie';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {LabourResolvePipe} from './pipes/resolvers/labour.resolve.pipe';
import {DuplicateComponent} from "./components/duplicate-component/duplicate.component";
import {MatListModule} from "@angular/material/list";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {RouterLink} from "@angular/router";

@NgModule({
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    MatCardModule,
    MatProgressBarModule,
    MatRadioModule,
    MatIconModule,
    NgxStripeModule.forRoot(environment.STRIPE_PUBLISHABLE_KEY),
    LottieComponent,
    MatCheckboxModule,
    MatListModule,
    MatSortModule,
    MatTableModule,
    RouterLink,
  ],
  declarations: [
    AsyncCurrencyPipe,
    InvoiceNumberPipe,
    CamelToTitleCasePipe,
    EmptyDashPipe,
    SafePipe,
    DurationPipe,
    DeleteConfirmationDirective,
    DeleteConfirmationComponent,
    InputNumberOnlyDirective,
    ProceedConfirmationDirective,
    ReadonlyStylingDirective,
    ProceedConfirmationComponent,
    CloseConfirmationComponent,
    LocalDateTimePipe,
    CreditorResolvePipe,
    DebtorResolvePipe,
    StockResolvePipe,
    UserResolvePipe,
    EngineResolvePipe,
    LabourResolvePipe,
    JobResolvePipe,
    PaymentGatewayComponent,
    SecurePayComponent,
    StripeComponent,
    DuplicateComponent
  ],
  exports: [
    AsyncCurrencyPipe,
    InvoiceNumberPipe,
    CamelToTitleCasePipe,
    EmptyDashPipe,
    SafePipe,
    DurationPipe,
    DeleteConfirmationDirective,
    ProceedConfirmationDirective,
    CloseConfirmationComponent,
    LocalDateTimePipe,
    ReadonlyStylingDirective,
    CreditorResolvePipe,
    DebtorResolvePipe,
    StockResolvePipe,
    UserResolvePipe,
    EngineResolvePipe,
    LabourResolvePipe,
    JobResolvePipe,
    MatMomentDateModule,
    InputNumberOnlyDirective,
    PaymentGatewayComponent,
    SecurePayComponent,
    StripeComponent,
    DuplicateComponent
  ]
})
export class CommonAppModule {
}
